import androidx.compose.foundation.isSystemInDarkTheme
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.ui.ExperimentalComposeUiApi
import androidx.compose.ui.Modifier
import androidx.compose.ui.window.CanvasBasedWindow
import com.nonopn.skywatcher.management.app.home.App
import org.jetbrains.compose.resources.configureWebResources
import org.jetbrains.skiko.wasm.onWasmReady

@OptIn(ExperimentalJsExport::class, ExperimentalComposeUiApi::class)
@JsExport
fun main() {
    onWasmReady {
        CanvasBasedWindow(
            title = "Sky Sentinel Admin"
        ) {
            configureWebResources {
                resourcePathMapping { path -> "/$path" }
            }
            Column(modifier = Modifier.fillMaxSize()) {
                App(isSystemInDarkTheme())
            }
        }
    }
}
